var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaForwardStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.625C8.75 0.3125 9.02344 0 9.375 0C9.6875 0 10 0.3125 10 0.625V6.95312V8.08594V14.375C10 14.7266 9.6875 15 9.375 15C9.02344 15 8.75 14.7266 8.75 14.375V9.10156L1.75781 14.7656C1.5625 14.9219 1.32812 15 1.05469 15C0.46875 15 0 14.5312 0 13.9453V1.09375C0 0.507812 0.46875 0 1.05469 0C1.32812 0 1.5625 0.117188 1.75781 0.273438L8.75 5.9375V0.625ZM1.25 1.44531V13.5938L8.67188 7.5L1.25 1.44531Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaForwardStepIcon);
export default __webpack_public_path__ + "static/media/faForwardStepIcon.cf8280b6127f77009306cb03e9f71d48.svg";
export { ForwardRef as ReactComponent };